import { useIntercomAppId } from '@/context/injectedValues/injectedValues'
import { useQuery } from '@apollo/client'
import Intercom from '@intercom/messenger-js-sdk'
import { useEffect, useMemo } from 'react'

import BREAKPOINTS from '@/constants/Breakpoints'

import { INTERCOM_PERSONAL_DETAILS } from './queries/IntercomPersonalDetailsQuery'

import { IntercomPersonalDetailsQuery } from './queries/__generated__/IntercomPersonalDetailsQuery'

import useWindowSize from '../useWindowSize'

const useIntercom = (
  visible = false,
  shouldSeeIntercom = false,
  mobileBottomOffset = '24px',
  desktopBottomOffset = '24px'
): void => {
  const { data } = useQuery<IntercomPersonalDetailsQuery>(
    INTERCOM_PERSONAL_DETAILS
  )
  const { windowWidth } = useWindowSize()

  const isMobile = useMemo(() => {
    return windowWidth < BREAKPOINTS.md
  }, [windowWidth])

  const dixaWidget = document.getElementsByClassName(
    'dixa-messenger-wrapper'
  )[0] as HTMLElement

  const intercomWidget = document.getElementsByClassName(
    'intercom-launcher'
  )[0] as HTMLElement

  const { intercomAppId } = useIntercomAppId()
  const intercomAvailable = useMemo(
    () => data && intercomAppId && shouldSeeIntercom,
    [data, intercomAppId, shouldSeeIntercom]
  )

  useEffect(() => {
    if (intercomAvailable && intercomAppId) {
      Intercom({
        app_id: intercomAppId,
        user_id: data?.user?.trackingId,
        name: `${data?.user?.firstName} ${data?.user?.lastName}`,
        email: data?.user?.email,
        created_at: data?.user?.numericalCreatedAt,
        user_hash: data?.user?.intercomUserHash
      })
      if (dixaWidget) {
        dixaWidget.remove()
      }
    }
  }, [intercomAvailable, data, intercomAppId, dixaWidget])

  useEffect(() => {
    if (!intercomAvailable || !intercomWidget) return

    if (visible) {
      intercomWidget.style.display = 'block'
    } else {
      intercomWidget.style.display = 'none'
    }

    if (isMobile) {
      intercomWidget.style.bottom = mobileBottomOffset
    } else {
      intercomWidget.style.bottom = desktopBottomOffset
    }
  }, [
    desktopBottomOffset,
    intercomAvailable,
    intercomWidget,
    isMobile,
    mobileBottomOffset,
    visible
  ])
}

export { useIntercom }
